"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadialBar = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var DateRange_1 = require("../DateRange");
var RadialBar = /** @class */ (function (_super) {
    __extends(RadialBar, _super);
    function RadialBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            apexModule: null,
        };
        _this.componentDidMount = function () { return __awaiter(_this, void 0, void 0, function () {
            var reactApexChart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("react-apexcharts")); })];
                    case 1:
                        reactApexChart = _a.sent();
                        this.setState({
                            apexModule: reactApexChart.default,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderChart = function () {
            var _a;
            var APEXModule = _this.state.apexModule;
            return (react_1.default.createElement(react_1.default.Fragment, null, APEXModule && (react_1.default.createElement(APEXModule, { options: {
                    plotOptions: {
                        radialBar: {
                            dataLabels: {
                                value: {
                                    formatter: function (value) {
                                        return value;
                                    },
                                },
                                total: {
                                    show: true,
                                    label: _this.props.title,
                                    formatter: function () {
                                        return "";
                                    },
                                },
                            },
                        },
                    },
                    labels: _this.props.labels,
                }, series: _this.props.series, type: "radialBar", height: (_a = _this.props.chartSize) !== null && _a !== void 0 ? _a : 300 }))));
        };
        return _this;
    }
    RadialBar.prototype.render = function () {
        var defaultClass = "flex flex-col justify-center bg-white overflow-hidden shadow rounded-lg pl-4 pb-3 w-full ";
        if (this.props.containerStyle)
            defaultClass += this.props.containerStyle;
        return !this.props.chartOnly ? (react_1.default.createElement("div", { className: defaultClass },
            react_1.default.createElement("div", { className: "ml-2 pr-5 my-4 flex flex-row items-center" },
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement("h3", { className: "text-lg truncate font-medium" }, this.props.title)),
                this.props.tool),
            react_1.default.createElement("div", { className: "mr-4" }, this.renderChart()),
            this.props.dateRangeVisible && (react_1.default.createElement(DateRange_1.DateRange, { className: "px-3", customDate: this.props.customDate, onChangeDate: this.props.onChangeDate })))) : (react_1.default.createElement("div", { className: this.props.containerStyle }, this.renderChart()));
    };
    return RadialBar;
}(react_1.Component));
exports.RadialBar = RadialBar;
//# sourceMappingURL=index.js.map